import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { FrontdeskService } from '../../services/frontdesk/frontdesk.service';
import { ToastService } from '../../services/toast/toast.service';
import { LoaderComponent } from '../../atoms/loader/loader.component';

@Component({
  selector: 'app-frontdesk-my-profile',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, LoaderComponent],
  templateUrl: './frontdesk-my-profile.component.html',
  styleUrl: './frontdesk-my-profile.component.scss',
})
export class FrontdeskMyProfileComponent implements OnInit {
  profile: any = {};
  email = new FormControl('');

  // mobile change (OTP-verified)
  newMobile = new FormControl('');
  otp = new FormControl('');
  otpId: number | null = null;
  otpStep: boolean = false;

  isLoading: boolean = false;

  constructor(
    private frontdeskService: FrontdeskService,
    private toastService: ToastService
  ) {}

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.isLoading = true;
    this.frontdeskService.getProfile().subscribe({
      next: (res: any) => {
        this.profile = res?.data || {};
        this.email.setValue(this.profile.email || '');
        this.isLoading = false;
      },
      error: (err) => {
        this.isLoading = false;
        this.toastService.error(err?.error?.message || 'Failed to load profile.');
      },
    });
  }

  saveEmail(): void {
    const email = (this.email.value || '').trim();
    if (!email) {
      this.toastService.error('Enter an email.');
      return;
    }
    this.isLoading = true;
    this.frontdeskService.updateEmail(email).subscribe({
      next: (res: any) => {
        this.toastService.success(res?.message || 'Email updated.');
        this.isLoading = false;
        this.load();
      },
      error: (err) => {
        this.isLoading = false;
        this.toastService.error(err?.error?.message || 'Failed to update email.');
      },
    });
  }

  requestOtp(): void {
    const mobile = (this.newMobile.value || '').trim();
    if (!mobile) {
      this.toastService.error('Enter the new mobile number.');
      return;
    }
    this.isLoading = true;
    this.frontdeskService.requestMobileOtp(mobile).subscribe({
      next: (res: any) => {
        this.otpId = res?.data?.otpId ?? null;
        this.otpStep = true;
        this.isLoading = false;
        this.toastService.success(res?.message || 'OTP sent.');
      },
      error: (err) => {
        this.isLoading = false;
        this.toastService.error(err?.error?.message || 'Failed to send OTP.');
      },
    });
  }

  verifyOtp(): void {
    const otp = (this.otp.value || '').trim();
    if (this.otpId == null || !otp) {
      this.toastService.error('Enter the OTP.');
      return;
    }
    this.isLoading = true;
    this.frontdeskService.verifyMobileOtp(this.otpId, otp).subscribe({
      next: (res: any) => {
        this.toastService.success(res?.message || 'Mobile number updated.');
        this.resetOtp();
        this.isLoading = false;
        this.load();
      },
      error: (err) => {
        this.isLoading = false;
        this.toastService.error(err?.error?.message || 'Failed to verify OTP.');
      },
    });
  }

  resetOtp(): void {
    this.otpStep = false;
    this.otpId = null;
    this.otp.setValue('');
    this.newMobile.setValue('');
  }
}
